import { render, staticRenderFns } from "./Opos.vue?vue&type=template&id=12296543&"
import script from "./Opos.vue?vue&type=script&lang=ts&"
export * from "./Opos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports